"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logrocket = void 0;
const LogRocket = require("logrocket");
const logRocketActions = {
    name: 'Logrocket',
    init: ({ appVersion, isProduction, bypassProductionCheck, tokens, }) => {
        if (!tokens['Logrocket']) {
            console.warn('Cannot initialize LogRocket. LogRocket app ID is not defined.');
            return false;
        }
        try {
            if (isProduction || bypassProductionCheck) {
                // Merge IFrames allows us to have the content of the iframe in log rocket sessions
                // Root Host Name control whether sessions that traverse different subdomains on your site
                // are kept intact or broken up into sessions specific to each subdomain
                LogRocket.init(tokens['Logrocket'], {
                    mergeIframes: true,
                    childDomains: ['*'],
                    release: `${appVersion}`,
                });
            }
        }
        catch (error) {
            console.error('LogRocket initialize failed.');
            return false;
        }
        return true;
    },
    identify: ({ userInfo, clinicInfo, isProduction, bypassProductionCheck, }) => {
        if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.id)) {
            console.warn('Cannot identify user in LogRocket. userInfo.id is not defined.');
            return false;
        }
        if (!clinicInfo) {
            console.warn('Cannot identify user in LogRocket. clinicInfo is not defined.');
            return false;
        }
        try {
            if (isProduction || bypassProductionCheck) {
                LogRocket.identify(userInfo === null || userInfo === void 0 ? void 0 : userInfo.id, {
                    name: userInfo.name || 'Unknown user',
                    email: userInfo.email || 'Unknown email',
                    userType: userInfo.type || 'Unknown user type',
                    clinicId: clinicInfo === null || clinicInfo === void 0 ? void 0 : clinicInfo.id,
                    clinicName: (clinicInfo === null || clinicInfo === void 0 ? void 0 : clinicInfo.name) || 'Unknown clinic',
                    environment: isProduction ? 'production' : 'development',
                });
            }
        }
        catch (error) {
            console.error('LogRocket identify failed.');
            return false;
        }
        return true;
    },
    track: ({ isProduction, bypassProductionCheck, eventData, eventName, }) => {
        try {
            if (isProduction || bypassProductionCheck) {
                LogRocket.track(eventName, eventData);
            }
        }
        catch (error) {
            console.error('LogRocket track failed.');
            return false;
        }
        return true;
    },
};
exports.Logrocket = logRocketActions;
//# sourceMappingURL=index.js.map